import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { localeDate, localeTime } from "helpers/formattedDate";
import Icon, { ICONS } from "shared/components/Icon";
import Button from "shared/components/buttons/Button";
import { useDispatch } from "react-redux";
import InputText from "shared/components/inputs/InputText";
import InputSelect from "shared/components/inputs/InputSelect";


import "./style.scss";

export default function TabInfo({ template }) {

    const [t] = useTranslation();
    const dispatch = useDispatch();



    return template && (
        <div className="admin-info">
            <div className="tab-info">
                <div className="section-general">
                    <h2>{t("admin.menu.html.template.review")}</h2>
                </div>
                <div className="divider" />
                <InputText
                    name="htmlTemplate"
                    label={t("book.edit.invitation.htmlContent")}
                    value={template.htmlContent}
                    readOnly
                    rules={{ required: true }}
                    multiline={true}  
                />
            </div>

        </div>)
        ;
}

TabInfo.propTypes = {
    template: PropTypes.object
};